export enum NotificationAlertFilterValue {
  UnreadAndRead = 'unreadAndRead',
  UnreadOnly = 'unreadOnly',
  Archived = 'archived',
}

export enum NotificationAlertBulkActionValue {
  MarkAllRead = 'markAllRead',
  ArchiveAllRead = 'archiveAllRead',
  ArchiveAll = 'archiveAll',
}

/** Filter option for notifications and alerts. */
export interface INotificationAlertFilterOption {
  label: string;
  value: NotificationAlertFilterValue;
  iconUrl: string;
}

/** Bulk action option for notifications and alerts. */
export interface INotificationAlertBulkActionOption {
  label: string;
  value: NotificationAlertBulkActionValue;
  iconUrl: string;
}

/** Item for notifications and alerts. */
export interface INotificationAlertItem {
  id: string;
  title: string;
  body: string;
  read_at: Date | null;
  sent_at: Date;
  archived_at: Date | null;
  iconPath: string;
  targetUrl: string;
}
